
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiDiodes01Off as ObiDiodes01OffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-diodes-01-off.js';
 
 
 

 
 export const ObiDiodes01Off = createComponent({
   react: React,
   tagName: 'obi-diodes-01-off',
   elementClass: ObiDiodes01OffElement,
   events: {
     
   }
  });
 
 